const breakpoints = {
  xxl: "1400px",
};

export default breakpoints;
